import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { PickupCreated, PickupLocation, PickupRelations, PickupRequest, PickupTemplate } from './pickup.models';

@Injectable({ providedIn: 'root' })
export class PickupService {
  private readonly endpoint = '/api/work_orders/pickups.php';

  constructor(private readonly http: HttpClient) {}

  relations(uuid: string) {
    return this.http.get<PickupRelations>(this.endpoint, { params: { action: 'relations', lading_uuid: uuid } });
  }

  template(uuid: string) {
    return this.http.get<PickupTemplate>(this.endpoint, { params: { action: 'options', lading_uuid: uuid } });
  }

  locations(uuid: string, query: string) {
    return this.http.get<{ ok: boolean; locations: PickupLocation[] }>(this.endpoint, {
      params: { action: 'options', lading_uuid: uuid, q: query }
    }).pipe(map(result => result.locations));
  }

  create(uuid: string, request: PickupRequest, key: string) {
    return this.http.post<{ ok: boolean; data: PickupCreated }>(this.endpoint, request, {
      params: { action: 'create', lading_uuid: uuid }, headers: { 'Idempotency-Key': key }
    });
  }

  document(uuid: string) {
    return this.http.get(this.endpoint, { params: { action: 'document', lading_uuid: uuid }, responseType: 'blob' });
  }
}
